export default __webpack_public_path__ + "static/hero-pattern-orange-b8ab410204ef542b7732602a5d511978.svg";